import * as types from 'model/actionTypes'
import { AnyAction } from 'redux'
import { DictT, UserProfileT } from 'model/types'

const initialState: DictT<UserProfileT> | null = null

export default function (state = initialState, action: AnyAction) {
  switch (action.type) {
    case types.RECEIVE_PROFILES:
      return action.profiles
    case types.CLEAR:
      return initialState
    case types.LOGOUT:
      return initialState
    default:
      return state
  }
}
